export default "/images/5d14a096e553464df1ae204cdb695bf2.avif";